import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import DriverLogin from "@/pages/DriverLogin";
import CustomerLogin from "@/pages/CustomerLogin";
import OperationsDashboard from "@/pages/OperationsDashboard";
import DriverDashboard from "@/pages/DriverDashboard";
import CustomerDashboard from "@/pages/CustomerDashboard";
import AccountingDashboard from "@/pages/AccountingDashboard";
import "@/App.css";

function roleHome(role) {
  return role === "admin" || role === "dispatcher" ? "/ops"
    : role === "accountant" ? "/accounting"
    : role === "driver" ? "/driver" : "/customer";
}

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground animate-pulse">Loading...</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={roleHome(user.role)} replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/driver/login" element={<DriverLogin />} />
          <Route path="/customer/login" element={<CustomerLogin />} />
          <Route path="/customer/verify" element={<CustomerLogin />} />
          <Route path="/ops" element={<Protected roles={["admin","dispatcher"]}><OperationsDashboard /></Protected>} />
          <Route path="/accounting" element={<Protected roles={["admin","dispatcher","accountant"]}><AccountingDashboard /></Protected>} />
          <Route path="/driver" element={<Protected roles={["driver"]}><DriverDashboard /></Protected>} />
          <Route path="/customer" element={<Protected roles={["customer"]}><CustomerDashboard /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster theme="light" position="top-right" toastOptions={{ style: { background: "#FFFFFF", border: "1px solid #DCE2E9", color: "#16283C", fontFamily: "IBM Plex Mono, monospace", fontSize: 12 } }} />
      </AuthProvider>
    </BrowserRouter>
  );
}
export default App;
